module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm04"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Prologue")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("“Y")])]), _vm._v("ou’re going home to Royal?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You heard me right. Can I get the family plane to pick me up?” Aaron Black persisted patiently on the phone, knowing his request was a shock to his brother.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re taking a leave of absence,” Jeb Black repeated. “I don’t believe it, but I’ll have the plane there as soon as possible. The diplomat from Spain, my worldly brother, is going to take a vacation in our hometown of Royal, Texas. I’m finding this damned difficult to believe.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The State Department has cleared it so I can take some time to go home,” Aaron said. “Dammit, you take vacations.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah, with the family and we go to one of those countries you work in. We don’t leave Houston to go back and sit around Royal.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Maybe you should. Royal is nice.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("“Yep, if you like cows and mesquite. I’ll bet you last two ")]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("days and then you’ll be calling me to send the plane to get you out of there. What about the embassy while you’re gone?”")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For the first time that day, Aaron was amused. He smiled in the darkness of his silent Georgetown house. “The American Embassy in Spain can carry on nicely if the First Secretary is not there for a little while.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not sure I’m talking to my brother. Aaron, are you all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m fine. Tell Mary and the boys hi for me. Better yet, give them a big hug. Thanks for sending the plane.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sure. Keep in touch. And tell me one more time that you’re okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m okay, ‘Mom.”’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, I’m your big brother and I have to take her place sometimes. And you’ll have to admit, this isn’t like you at all. Aaron—does this have something to do with the Texas Cattleman’s Club?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, it does,” Aaron could answer honestly. His brother wasn’t a member, but he could have been and he knew that the club was a facade for members to work together covertly on secret missions to save innocents’ lives.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why didn’t you tell me,” Jeb said, sounding more relaxed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Take care of yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thanks, Jeb.” Aaron replaced the receiver, breaking the connection with his older brother. Aaron stared out the window at the swirling snow. “No, it isn’t like me,” he whispered to himself. “Thanks to a tall, black-haired Texas gal, I’m doing things I’ve never done in my life.” Mesmerized by the swirling snow and twinkling lights, he remembered early January, three weeks ago, the night of the Cattleman’s Club gala.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("Aaron’s pulse accelerated as he recalled the moment he had glanced across the room and seen the willowy, black-haired woman in a simple black dress. When she’d turned, her blue-eyed gaze had met his and, just for an instant, he’d felt something spark inside him. She was laughing at something someone else had said to her. Seeing her wide blue eyes, dimples and irresistible smile, Aaron had a sudden, unreasonable com")]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("pulsion to meet her. He’d thought he knew almost everyone in Royal, but she was a stranger.")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Then Justin Webb had spoken to him and he’d turned to shake hands with his physician friend. The next time he’d looked back, the woman was gone from sight. It had taken him twenty more minutes to work his way through the crowd and get introduced. Another two minutes and he had her in his arms, moving on the dance floor. And then later—images taunted him of her in his arms, of the heat of her kisses, her eagerness—memories still fresh enough that his body reacted swiftly to them. Pamela Miles.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Breaking into his thoughts, a car slid to a stop before his Georgetown home and Brad Meadows, his stocky neighbor, emerged. Brad walked around the car to open the door for his wife, and then he opened the back door and leaned inside. In minutes he straightened up with his little girl in his arms. As they rushed toward their front door, they were all laughing, but then the curly-headed three-year-old looked at Aaron’s house and evidently saw him standing in the window because she smiled and waved. Feeling a pang as he watched them, Aaron smiled and waved in return.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Brad Meadows had a family, a beautiful wife and a precious little girl. Aaron ran his hand across his forehead as Pamela’s image floated into his thoughts again. “What the hell is the matter with me?” he mumbled. Since when did he envy a guy being "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("married?")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Yet he thought about his own family when he was growing up and what fun he’d had with his two brothers and sister. He glanced around his quiet living room. Empty house, empty life.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("The thought nagged at him—why did he feel this way so often lately? Except that night with Pamela Miles. The loneliness, the feeling that he was missing something important in life, the hollowness he had been experiencing the last few years had vanished from the first moment he’d looked into her eyes. From that first glance the chemistry between them had been volatile. It had erupted into fiery lovemaking that at the ")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("slightest memory could make him break into a sweat. But there was something deeper than physical need. At least there had been for him.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The next morning she had been the one who’d slipped out without a word. When he’d stirred, she was gone. He had tried to shrug off the evening. When had he let a woman tie him in knots? If the lady wanted to end it that way—fine. He had to return to Washington and then to Spain and his busy life. And he knew she was going abroad to Asterland as an exchange teacher. If he wanted, he could look her up there after he was back in Spain.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He had left Royal without seeing her, flown back to D.C. and then to Spain. Two days after the ball, a private jet had left Royal, Texas, bound for Asterland with Pamela Miles on board. Not far from Royal, the plane had had to make an emergency landing. When Matt Walker, a rancher and a fellow member of the Texas Cattleman’s Club, called about the landing and about other strange happenings in Royal, Aaron had tried to call Pamela, but to no avail.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The hospital had released Pamela soon after the landing and Aaron knew so little about her, he couldn’t easily find her. It was clear that the lady wasn’t interested in seeing him, so he tried to put her out of mind.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But Pamela Miles had a persistent way of staying in his thoughts until he was driven to constant distraction—something so foreign to his life that he decided to see her again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As he watched snowflakes swirl and melt on the slushy narrow Georgetown street, an emptiness struck him with a chill that was far colder than the snow. He had gone into the diplomatic corps from Army intelligence, thinking he could make a difference, help change things a little in the world, but now he was losing that feeling.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lately he had been too aware of his thirty-seven years and what little he had in his life that was really important. But the night of the Texas ball, that desolation had vanished. Pamela had brought him to life to an extent he wouldn’t have guessed possible.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He swore, looking at the phone in his hand as an annoyingly loud recorded message told him his receiver was off the hook.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Aaron stared out the window, no longer seeing swirling snow or the neighboring houses with warm glows spilling from open windows. He was seeing sprawling, mesquite-covered land and a willowy, blue-eyed woman.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Dammit,” he said. “Pamela, I know there was something you felt as much as I did.” He shook his head. He was being a world-class sap. The lady wasn’t interested. She had made that clear. Maybe so, but he was going home to find out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The following afternoon, the last day of January, Aaron gripped the wheel of a family car left for him at the airport as he sped down the hard-packed dusty road toward a sprawling ranch in the distance. Mesquite trees bending to the north by prevailing southern winds dotted the land on either side of the road, but all he could think about was Pamela.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was home and he was going to find his lady.")])])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page11"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf56e2bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459206588_fm04.vue
// module id = 78
// module chunks = 0